"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _zxcvbn = _interopRequireDefault(require("zxcvbn"));
require("../styles/passwordStrengthMeter.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PasswordStrengthMeter = _ref => {
  let {
    password
  } = _ref;
  if (!password) return null;
  const testedResult = (0, _zxcvbn.default)(password).score;
  const createPasswordLabel = result => {
    switch (result) {
      case 0:
        return "Weak";
      case 1:
        return "Weak";
      case 2:
        return "Fair";
      case 3:
        return "Good";
      case 4:
        return "Strong";
      default:
        return "Weak";
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "password-strength-meter"
  }, /*#__PURE__*/_react.default.createElement("progress", {
    className: "password-strength-meter-progress strength-".concat(testedResult),
    value: testedResult,
    max: "4"
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("label", {
    className: "password-strength-meter-label"
  }, password && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", null, "Password strength:"), " ", createPasswordLabel(testedResult))));
};
var _default = PasswordStrengthMeter;
exports.default = _default;